var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkflowsWhen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.024 2.392a.75.75 0 0 1 1.178.803l-2.62 8.981 3.761.488a.75.75 0 0 1 .36 1.339L8.59 22.535a.75.75 0 0 1-1.175-.812l2.643-8.751-3.998-.519a.75.75 0 0 1-.361-1.338l11.325-8.723Zm-8.976 8.807 3.08.4a.751.751 0 0 1 .62.96l-2.223 7.367 7.826-6.008-2.83-.367a.75.75 0 0 1-.623-.953l2.22-7.616-8.07 6.217Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowsWhen);
export default __webpack_public_path__ + "static/media/workflows-when.292e9407c54e8424504d347fa0881c43.svg";
export { ForwardRef as ReactComponent };